var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthLayout',{staticClass:"mr-12"},[_c('PrivateCustomHeaderTitle',{attrs:{"title":_vm.$t('allPrivatePages.messages.title')}}),_c('ChatMessages',{class:{'mr-20': _vm.toggleChat}}),_c('MessageFilesNavDrawer',{on:{"toggleFileDrawer":_vm.toggleFileDrawer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }